const treeItem = {
    labelFiller: '[NO NAME]'
};

export default treeItem;